import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import SwipeableViews from 'react-swipeable-views';
import styled, { css } from 'styled-components';
import withMatch from '@/hocs/withMatch';
import { getResultData } from '../../../redux/apiData';
import { connect } from 'react-redux';
import { colorPalette } from '../../../styles/styleGuide';
import { darken } from '../../../styles/utils';
import { fromBreakpoint, toBreakpoint, breakpointSizes } from '../../../styles/breakpoints';
import Caret from '../icons/Caret';
import CircleArrow from '../icons/CircleArrow';
import SliderSlide from './SliderSlide';
import ObserveSize from '../../ObserveSize';
import get from 'lodash.get';
import DownloadButton from '../buttons/ButtonDownload';
import formatCmsImageUrl from '../../../services/formatCmsImageUrl';
var defaultProps = {
  showPrimaryArrows: true,
  showBullets: true,
  size: 'normal'
};
var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    styling: get(getResultData(state.apiData, 'getSettings', {
      projectSlug: String(ownProps.match.params.projectSlug),
      env: String(ownProps.match.params.env)
    }), 'styling', {})
  };
};
var Slider = /*#__PURE__*/function (_Component) {
  function Slider() {
    var _this;
    _classCallCheck(this, Slider);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Slider, [].concat(args));
    _defineProperty(_this, "state", {
      swipeIndex: _this.props.currentIndex ? _this.props.currentIndex : 0,
      renderWidth: 0
    });
    // Returns cover if image 'amost fits', otherwise contain
    _defineProperty(_this, "getImageFit", function (image, heightRatio) {
      return image ? Math.abs(image.height / image.width - heightRatio) > 0.1 ? 'contain' : 'cover' : 'cover';
    });
    return _this;
  }
  _inherits(Slider, _Component);
  return _createClass(Slider, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        heightRatio = _this$props.heightRatio,
        styling = _this$props.styling,
        _this$props$heroes = _this$props.heroes,
        heroes = _this$props$heroes === void 0 ? [] : _this$props$heroes,
        showBullets = _this$props.showBullets,
        size = _this$props.size,
        showPrimaryArrows = _this$props.showPrimaryArrows,
        showSecondaryArrows = _this$props.showSecondaryArrows,
        showDownloadButton = _this$props.showDownloadButton,
        paginationColor = _this$props.paginationColor;
      var _this$state = this.state,
        swipeIndex = _this$state.swipeIndex,
        renderWidth = _this$state.renderWidth;
      var themeColor = styling.button;
      var calculatedHeightRatio = heightRatio || 820 / 1180;
      var singleSlide = !heroes || heroes.length === 1;
      var shouldPrimaryArrowsBeDisplayed = this.state.renderWidth < breakpointSizes.md ? false : showPrimaryArrows;
      return __jsx(Wrapper, {
        "data-id": "ui_Slider_Wrapper"
      }, __jsx(ObserveSize, {
        observerFn: function observerFn(contentRect) {
          return _this2.setState({
            renderWidth: contentRect.width
          });
        },
        "data-id": "ui_Slider_ObserveSize"
      }, __jsx(ButtonSpace, {
        singleSlide: singleSlide,
        hasArrows: shouldPrimaryArrowsBeDisplayed,
        "data-id": "ui_Slider_ButtonSpace"
      }, __jsx(SlideView, {
        singleSlide: singleSlide,
        heightRatio: calculatedHeightRatio,
        "data-id": "ui_Slider_SlideView"
      }, __jsx(InnerView, {
        "data-id": "ui_Slider_InnerView"
      }, heroes && (singleSlide ? __jsx(SliderSlide, {
        slide: heroes[0],
        fit: this.getImageFit(heroes[0].image, calculatedHeightRatio),
        sliderWidth: renderWidth,
        isCurrent: true,
        "data-id": "ui_Slider_SliderSlide"
      }) : __jsx(SwipeableViews, {
        index: swipeIndex,
        onChangeIndex: function onChangeIndex(index) {
          return _this2.setState({
            swipeIndex: index
          });
        },
        resistance: true,
        ignoreNativeScroll: true,
        style: {
          height: '100%'
        },
        containerStyle: {
          height: '100%'
        },
        slideStyle: {
          height: '100%'
        },
        "data-id": "ui_Slider_SwipeableViews"
      }, heroes.map(function (hero, index) {
        return hero ? __jsx(SliderSlide, {
          key: index,
          fit: _this2.getImageFit(hero.image, calculatedHeightRatio),
          slide: hero,
          sliderWidth: renderWidth,
          isCurrent: swipeIndex === index,
          "data-id": "ui_Slider_SliderSlide"
        }) : null;
      })))), shouldPrimaryArrowsBeDisplayed && [__jsx(ArrowPrimaryNext, {
        key: "next",
        onClick: function onClick() {
          return _this2.setState({
            swipeIndex: swipeIndex + 1
          });
        },
        disabled: !heroes || swipeIndex >= heroes.length - 1,
        "aria-label": "Volgende",
        "data-id": "ui_Slider_ArrowPrimaryNext"
      }, __jsx(Caret, {
        direction: "right",
        color: colorPalette.white,
        "data-id": "ui_Slider_Caret"
      })), __jsx(ArrowPrimaryPrev, {
        key: "prev",
        onClick: function onClick() {
          return _this2.setState({
            swipeIndex: swipeIndex - 1
          });
        },
        disabled: !heroes || swipeIndex === 0,
        "aria-label": "Vorige",
        "data-id": "ui_Slider_ArrowPrimaryPrev"
      }, __jsx(Caret, {
        direction: "left",
        color: colorPalette.white,
        "data-id": "ui_Slider_Caret"
      }))], showSecondaryArrows && [__jsx(ArrowSecondaryNext, {
        key: "next",
        onClick: function onClick() {
          return _this2.setState({
            swipeIndex: swipeIndex + 1
          });
        },
        disabled: !heroes || swipeIndex >= heroes.length - 1,
        "aria-label": "Volgende",
        "data-id": "ui_Slider_ArrowSecondaryNext"
      }, __jsx(CircleArrow, {
        direction: "right",
        color: colorPalette.white,
        "data-id": "ui_Slider_CircleArrow"
      })), showDownloadButton && __jsx(DownloadButtonBase, {
        key: swipeIndex,
        "data-id": "ui_Slider_DownloadButtonBase"
      }, __jsx(DownloadButton, {
        key: swipeIndex,
        link: heroes && heroes ? formatCmsImageUrl(0, 0, heroes[swipeIndex].image.src, false) : '/',
        content: "",
        image: true,
        "data-id": "ui_Slider_DownloadButton"
      })), __jsx(ArrowSecondaryPrev, {
        key: "prev",
        onClick: function onClick() {
          return _this2.setState({
            swipeIndex: swipeIndex - 1
          });
        },
        disabled: !heroes || swipeIndex === 0,
        "aria-label": "Vorige",
        "data-id": "ui_Slider_ArrowSecondaryPrev"
      }, __jsx(CircleArrow, {
        direction: "left",
        color: colorPalette.white,
        "data-id": "ui_Slider_CircleArrow"
      }))])), showBullets && heroes && heroes.length > 1 && __jsx(DotView, {
        "data-id": "ui_Slider_DotView"
      }, heroes && heroes.map(function (hero, index) {
        return __jsx(Button, {
          key: index,
          onClick: function onClick() {
            return _this2.setState({
              swipeIndex: index
            });
          },
          isActive: swipeIndex === index,
          size: size,
          color: paginationColor || themeColor,
          "aria-label": "Navigeer naar slide ".concat(index),
          "data-id": "ui_Slider_Button"
        }, __jsx(Bullet, {
          color: paginationColor || themeColor,
          "data-id": "ui_Slider_Bullet"
        }));
      }))));
    }
  }]);
}(Component);
_defineProperty(Slider, "defaultProps", defaultProps);
export default withMatch(connect(mapStateToProps)(Slider));
var Wrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-left: auto;\n  margin-right: auto;\n"])));
var SlideView = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  padding-top: ", "%;\n"])), function (props) {
  return props.heightRatio * 100;
});
var ButtonSpace = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: relative;\n  ", ";\n"])), function (props) {
  return props.hasArrows ? 'margin: 0 20rem;' : '';
});
var InnerView = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  background-color: ", ";\n  box-shadow: 0 0 20rem 0 rgba(0, 0, 0, 0.25);\n"])), colorPalette.lightGrey);
var ArrowStyle = css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 1;\n  opacity: 0.85;\n  background-color: ", ";\n  width: 40rem;\n  height: 40rem;\n  border-radius: 50%;\n  transition: opacity 0.2s ease-in-out;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  -webkit-tap-highlight-color: transparent;\n  ", ";\n"])), colorPalette.lightBeige, function (props) {
  return props.disabled ? 'opacity: 0; pointer-events: none;' : ' &:hover { opacity: 1; } ';
});
var ArrowCircleStyle = css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%) scale(1);\n  z-index: 1;\n  opacity: 0.85;\n  width: 60rem;\n  height: 60rem;\n  border-radius: 50%;\n  transition: opacity 0.2s ease-in-out;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  -webkit-tap-highlight-color: transparent;\n  ", ";\n  ", ";\n"])), function (props) {
  return props.disabled ? 'opacity: 0; pointer-events: none;' : ' &:hover { opacity: 1; } ';
}, toBreakpoint.md(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n      transform: translateY(-50%) scale(.6);\n  "]))));
var DownloadButtonBase = styled.button(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  position: relative;\n  transform: translateY(-50%) scale(1);\n  z-index: 10;\n  opacity: 1;\n  width: 100%;\n  height: auto;\n  border-radius: 50%;\n  transition: opacity 0.2s ease-in-out;\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-end;\n  -webkit-tap-highlight-color: transparent;\n  opacity: 1;\n  ", ";\n  right: 20px;\n  bottom: 20px;\n"])), toBreakpoint.md(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n      bottom: 5px;\n  "]))));
var ArrowPrimaryNext = styled.button(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n  ", ";\n  right: -20rem;\n"])), ArrowStyle);
var ArrowPrimaryPrev = styled.button(_templateObject1 || (_templateObject1 = _taggedTemplateLiteral(["\n  ", ";\n  left: -20rem;\n"])), ArrowStyle);
var ArrowSecondaryNext = styled.button(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  ", ";\n  right: 20rem;\n"])), ArrowCircleStyle);
var ArrowSecondaryPrev = styled.button(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  ", ";\n  left: 20rem;\n"])), ArrowCircleStyle);
var DotView = styled.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: flex-end;\n  width: 100%;\n  padding-top: 15rem;\n"])));
var Bullet = styled.span(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: 50%;\n\n  &:hover {\n    background-color: ", ";\n  }\n"])), function (props) {
  return props.color ? props.color : colorPalette.lightBlue;
}, function (props) {
  return props.color ? props.color : colorPalette.blue;
});
var Button = styled.button(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  width: ", ";\n  height: 12rem;\n  display: flex;\n  align-content: center;\n  justify-content: center;\n  -webkit-tap-highlight-color: transparent;\n\n  > span {\n    width: ", ";\n    height: ", ";\n    transition: background-color 0.25s ease-in-out;\n\n    background-color: ", ";\n  }\n\n  ", ";\n"])), function (props) {
  return props.size === 'small' ? '15rem' : '25rem';
}, function (props) {
  return props.size === 'small' ? '8rem' : '12rem';
}, function (props) {
  return props.size === 'small' ? '8rem' : '12rem';
}, function (props) {
  return props.isActive && props.color ? "".concat(darken(props.color, 15)) : props.isActive ? colorPalette.darkBlue : '';
}, fromBreakpoint.md(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n    width: ", ";\n\n    > span {\n      width: ", ";\n      height: ", ";\n    }\n"])), function (props) {
  return props.size === 'small' ? '15rem' : '25rem';
}, function (props) {
  return props.size === 'small' ? '8rem' : '12rem';
}, function (props) {
  return props.size === 'small' ? '8rem' : '12rem';
}));